/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { queryEncode } from 'cio/helpers/query';

interface SendEventModalCustomerSearchArgs {
  onSearch: (opts: { id: string } | { email: string } | { filters: string | null }) => unknown;
  onClearSearch: () => unknown;
  canSearchByPersonId: boolean;
}

enum SearchOptions {
  Email = 'Email',
  Filters = 'Filters',
  Id = 'Id',
}

type Condition = any;

export default class SendEventModalCustomerSearch extends Component<SendEventModalCustomerSearchArgs> {
  readonly searchOptions = SearchOptions;
  readonly conditionTypes = ['attribute'];

  @tracked searchTerm = '';
  @tracked customerId = '';
  @tracked searchingBy = SearchOptions.Email;
  @tracked attributeCondition: Condition = { operator: '=', type: 'attribute' };
  @tracked isEditingAttributeCondition = true;

  @action
  searchBy(option: SearchOptions) {
    this.searchingBy = option;
    this.args.onClearSearch();
  }

  @action
  onSearch(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.args.onSearch({ email: searchTerm });
  }

  @action
  conditionUpdate(condition: Condition) {
    this.attributeCondition = condition;
    this.setIsEditingAttributeCondition(false);
    this.args.onSearch({ filters: queryEncode([condition]) });
  }

  @action
  conditionDelete() {
    this.attributeCondition = { operator: '=', type: 'attribute' };
    this.setIsEditingAttributeCondition(true);
    this.args.onClearSearch();
  }

  @action
  setIsEditingAttributeCondition(isEditing: boolean) {
    this.isEditingAttributeCondition = isEditing;
  }

  @action
  searchById(ev: Event) {
    ev.preventDefault();

    if (!this.customerId) {
      return;
    }

    this.args.onSearch({ id: this.customerId });
  }
}
